// extracted by mini-css-extract-plugin
module.exports = {"logoTitle":"LogoTitle_logoTitle__2IuP3","title":"LogoTitle_title__1yU85","logo":"LogoTitle_logo__214Ty"};